/**
 * Copyright © 2026 Adnuntius AS.
 */
import {BrowserLocationService} from '../../app/angular-platform-providers';
import {Injectable, Injector} from '@angular/core';
import * as _ from 'lodash';

import {AuthService} from './auth.service';
import {UpdateSession} from '../session/update-session';
import {LocalNetworkProfile} from '../session/local-network-profile';
import {AdnHttpRequest} from '../util/adn-http.service';

@Injectable({
  providedIn: 'root'
})
export class AuthHttpInterceptorService {
  private LocalNetworkProfile: any;
  private location: any;

  constructor(
    private readonly AuthService: AuthService,
    // LocalNetworkProfile → Network → AdnHttp → this interceptor. Resolve
    // LocalNetworkProfile and BrowserLocationService lazily to avoid importing
    // the session graph into this module.
    private readonly injector: Injector
  ) {
  }

  prepare(config: AdnHttpRequest): AdnHttpRequest {
    const configUrl = config.url || '';
    if (!config.cache && (configUrl.indexOf('api') > -1 || configUrl.indexOf('preview') > -1) || configUrl.indexOf('synchronous') > -1) {
      const params: any = {};
      const updateSession = UpdateSession.obtainData();
      this.location = this.location || this.injector.get(BrowserLocationService);
      const useUpdateSession = updateSession.authToken && UpdateSession.isAdvertiserUpdatePath(this.location.pathname);
      if (useUpdateSession) {
        params.auth_token = updateSession.authToken;
        params.context = updateSession.context;
        config.headers = _.assign({}, config.headers, {Authorization: 'Bearer ' + updateSession.authToken});
      } else if (this.AuthService.isValidSession()) {
        const token = this.AuthService.getSessionData().accessToken;
        if (_.startsWith(config.url, 'https:')) {
          params.auth_token = token;
        } else {
          config.headers = _.assign({}, config.headers, {Authorization: 'Bearer ' + token});
        }
      }

      const hasExplicitContext = _.has(config, ['params', 'context']);
      const preserveExplicitContext = hasExplicitContext
        && (config.params.context === null || config.preserveContext === true);
      if (!params.context && !preserveExplicitContext) {
        this.LocalNetworkProfile = this.LocalNetworkProfile || this.injector.get(LocalNetworkProfile);
        const networkId = this.LocalNetworkProfile.get('networkId');
        const tagId = this.LocalNetworkProfile.get('tagId');
        if (configUrl.indexOf('preview') > -1) {
          params.context = networkId || 'placeholder-network';
        } else if (configUrl.indexOf('releasenotes') < 0) {
          params.context = tagId || networkId;
        }
      }
      if (!params.context && useUpdateSession && updateSession.context) {
        params.context = updateSession.context;
      }
      config.params = _.assign({}, config.params, params);
    }
    return config;
  }
}
